let vue;

export default {
  install(config) {
    vue.prototype.$config = Object.freeze(config)
  },
  initialize(Vue) {
    vue = Vue
  }
}